import { useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const VIDEO_ID = "4F8fdpW3N_w";

export default function HeroVideo() {
    const [playing, setPlaying] = useState(false);

    return (
        <section
            id="video"
            className="relative border-t border-white/10 bg-navy-950"
            data-testid="hero-video"
        >
            <div className="mx-auto max-w-6xl px-6 py-20 md:px-12 md:py-24">
                <Reveal>
                    <div className="mb-6 flex flex-wrap items-center gap-4">
                        <span className="h-px w-10 bg-gold/60" />
                        <span className="font-mono text-xs uppercase tracking-[0.25em] text-gold">
                            Watch · 8-Min Pitch
                        </span>
                        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
                            Kyle Kemper, President
                        </span>
                    </div>
                </Reveal>

                <Reveal delay={0.1}>
                    <h2 className="mb-10 max-w-3xl font-display text-3xl md:text-4xl font-light leading-tight tracking-tight text-white">
                        A personal introduction to HEIR.
                    </h2>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="relative overflow-hidden border border-white/10">
                        <div className="relative aspect-video bg-navy-900">
                            {playing ? (
                                <iframe
                                    title="HEIR Investor Pitch — Kyle Kemper"
                                    src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0&modestbranding=1`}
                                    className="absolute inset-0 h-full w-full"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                />
                            ) : (
                                <button
                                    onClick={() => setPlaying(true)}
                                    data-testid="hero-video-play"
                                    aria-label="Play HEIR investor pitch video"
                                    className="group absolute inset-0 flex items-center justify-center"
                                >
                                    <img
                                        src={`https://i.ytimg.com/vi/${VIDEO_ID}/maxresdefault.jpg`}
                                        alt="HEIR Investor Pitch by Kyle Kemper"
                                        onError={(e) => {
                                            e.currentTarget.src = `https://i.ytimg.com/vi/${VIDEO_ID}/hqdefault.jpg`;
                                        }}
                                        className="absolute inset-0 h-full w-full object-cover opacity-80 transition-all duration-700 group-hover:scale-[1.02] group-hover:opacity-95"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-navy-950/70 via-transparent to-navy-950/30" />

                                    <motion.div
                                        whileHover={{ scale: 1.08 }}
                                        transition={{
                                            duration: 0.45,
                                            ease: [0.22, 1, 0.36, 1],
                                        }}
                                        className="relative flex h-20 w-20 items-center justify-center border border-gold bg-gold/[0.12] backdrop-blur-sm transition-colors duration-300 group-hover:bg-gold"
                                    >
                                        <Play
                                            className="h-7 w-7 translate-x-0.5 fill-gold text-gold transition-colors duration-300 group-hover:fill-navy-950 group-hover:text-navy-950"
                                            strokeWidth={1.25}
                                        />
                                    </motion.div>

                                    <div className="absolute bottom-4 left-4 border border-gold/40 bg-navy-950/70 px-4 py-2 backdrop-blur-sm">
                                        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">
                                            8-Minute Pitch · Kyle Kemper
                                        </span>
                                    </div>
                                </button>
                            )}
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
